var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        eager: "",
        persistent: "",
        fullscreen: "",
        transition: "scroll-y-transition",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-app-bar",
        {
          staticClass: "white--text navy",
          attrs: {
            absolute: "",
            "elevate-on-scroll": "",
            "scroll-target": "#scrolling-techniques-7",
          },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { depressed: "", icon: "" },
              on: { click: _vm.dismiss },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "secondary",
              attrs: {
                small: "",
                depressed: "",
                rounded: "",
                disabled: _vm.isAstaInCorso,
              },
              on: { click: _vm.save },
            },
            [_vm._v("SALVA")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-sheet",
        {
          ref: "scrollContainer",
          staticClass: "overflow-y-auto",
          class: { "nice-scroll": !_vm.is_mobile },
          attrs: { id: "scrolling-techniques-7", "max-height": "100%" },
        },
        [
          _c(
            "v-container",
            {
              staticClass: "white",
              staticStyle: { "margin-top": "48px" },
              attrs: { fluid: "", "pa-0": "" },
            },
            [
              _vm.isAstaInCorso
                ? _c(
                    "div",
                    {
                      staticClass:
                        "pa-6 error white--text d-flex flex-column align-center justify-center",
                      attrs: { id: "semaforo" },
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          "\n          Non è possibile modificare le impostazioni mentre l'asta è in corso!\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("semaforo", {
                        staticClass: "mt-2",
                        attrs: {
                          mode: "bar",
                          buttons: ["play", "pause", "stop"],
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c("v-col", [
                    _c(
                      "div",
                      { staticClass: "modalita" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-center mb-4" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "px-4 py-1 rounded white--text text--darken-3",
                              },
                              [
                                _vm._v(
                                  "\n                SELEZIONA MODALITA' ASTA\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          { attrs: { justify: "center", align: "center" } },
                          _vm._l(_vm.asta_modes, function (asta_mode) {
                            return _c(
                              "v-col",
                              { key: asta_mode, attrs: { cols: "auto" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "asta-mode navy darken-3",
                                    class: {
                                      selezionato: asta_mode == _vm.mode,
                                    },
                                    attrs: { elevation: "0" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setMode(asta_mode)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {},
                                      [
                                        _c("v-img", {
                                          attrs: {
                                            contain: "",
                                            src:
                                              _vm.firebase_host +
                                              "/static/img/asta-mode-" +
                                              asta_mode +
                                              ".png",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "px-5 pb-4 text-center",
                                          },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "font-hemi-head white--text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.getAstaModeName(
                                                        asta_mode
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      asta_mode != _vm.mode,
                                                    expression:
                                                      "asta_mode != mode",
                                                  },
                                                ],
                                              },
                                              [_vm._v("SELEZIONA")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "modalita-info white--text primary",
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary darken-2" } },
                                    [_vm._v(" school ")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getAstaModeLongDescr(_vm.mode)
                                      ),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-card", { staticClass: "page-impostazioni" }, [
                        _c(
                          "div",
                          { staticClass: "text-center mb-4" },
                          [
                            _c("v-icon", { attrs: { color: "text" } }, [
                              _vm._v(" settings "),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.Config.STANDALONE && 1 == 2
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("outlined_flag")]
                                        ),
                                        _vm._v(
                                          "STATO\n                  MERCATO\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v(
                                          "\n                  L'amministratore di lega deve attivare questo mercato prima\n                  di poterlo utilizzare.\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "opzione-widget" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-decoration-none",
                                      attrs: {
                                        target: "_blank",
                                        href:
                                          _vm.Config.HOST +
                                          "/fantacalcio/modifica-statoMercato/" +
                                          _vm.asta_info.lega.ID_Lega +
                                          "/3",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            depressed: "",
                                            large: "",
                                            outlined: "",
                                            disabled: _vm.isAstaInCorso,
                                          },
                                        },
                                        [
                                          _vm.asta_info.statoMercato == 0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "statoMercato statoMercato-red",
                                                },
                                                [_vm._v("NON ATTIVO")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "statoMercato statoMercato-green",
                                                },
                                                [_vm._v("ATTIVO")]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("edit")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                right: "",
                                              },
                                            },
                                            [_vm._v("open_in_new")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("engineering")]
                                  ),
                                  _vm._v(
                                    "AMMINISTRATORE\n                  ASTA\n                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v(
                                  "\n                  L'amministratore d'asta deve rimanere sempre online durante\n                  il corso dell'asta o Asta Live si bloccherà.\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "opzione-widget" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      large: "",
                                      disabled: _vm.isAstaInCorso,
                                      outlined: "",
                                    },
                                    on: { click: _vm.promptChangeAdmin },
                                  },
                                  [
                                    _vm.isAdminSet
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.adminUsername) +
                                              "\n                    "
                                          ),
                                          _c("span", {
                                            staticClass: "stato",
                                            class: _vm.adminPresenceClass,
                                          }),
                                        ])
                                      : _c("span", [_vm._v("Imposta")]),
                                    _vm._v(" "),
                                    _c("v-icon", { attrs: { right: "" } }, [
                                      _vm._v("edit"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.Config.STANDALONE
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("groups")]
                                        ),
                                        _vm._v("MAX SQUADRE\n                "),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _c(
                                      "v-btn",
                                      { attrs: { large: "", outlined: "" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.asta_info.lega.maxSquadre
                                            ) +
                                            "\n                  "
                                        ),
                                        _c("v-icon", { attrs: { right: "" } }, [
                                          _vm._v("lock"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.Config.STANDALONE
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("tune")]
                                        ),
                                        _vm._v(
                                          "TIPOLOGIA RUOLI\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _c(
                                      "v-btn",
                                      { attrs: { large: "", outlined: "" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.tipoRuoli.toUpperCase()
                                            ) +
                                            "\n\n                  "
                                        ),
                                        _c("v-icon", { attrs: { right: "" } }, [
                                          _vm._v("lock"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.Config.STANDALONE
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("groups")]
                                        ),
                                        _vm._v(
                                          "MODIFICA RUOLI\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _vm.classic
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              large: "",
                                              disabled: _vm.isAstaInCorso,
                                              outlined: "",
                                            },
                                            on: {
                                              click: _vm.promptRuoliCustom,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "PERSONALIZZA RUOLI\n                  "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "v-btn",
                                          {
                                            attrs: { large: "", outlined: "" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Non modificabili\n                  "
                                            ),
                                            _c(
                                              "v-icon",
                                              { attrs: { right: "" } },
                                              [_vm._v("lock")]
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("production_quantity_limits")]
                                  ),
                                  _vm._v("ROSA\n                "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v(
                                  "\n                  Numero calciatori da dover comprare per ciascun ruolo\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            !_vm.Config.STANDALONE
                              ? _c("div", { staticClass: "opzione-widget" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-decoration-none",
                                      attrs: {
                                        target: "_blank",
                                        href:
                                          _vm.Config.HOST +
                                          "/fantacalcio/mercato-modifica-n-ruoli/" +
                                          _vm.asta_info.id,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            depressed: "",
                                            large: "",
                                            outlined: "",
                                            disabled: _vm.isAstaInCorso,
                                          },
                                        },
                                        [
                                          _vm.nRuoliComputed &&
                                          _vm.nRuoliComputed.op == "illimitati"
                                            ? _c("div", [
                                                _c("span", [
                                                  _vm._v("Illimitati"),
                                                ]),
                                              ])
                                            : _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.prefixAcquistabiliPerRuolo()
                                                    )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _vm._v(" "),
                                                _vm.nRuoliComputed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Ruolo outline Ruolo_1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nRuoliComputed
                                                              .nP
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.nRuoliComputed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Ruolo outline Ruolo_2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nRuoliComputed
                                                              .nD
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.nRuoliComputed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Ruolo outline Ruolo_3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nRuoliComputed
                                                              .nC
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.nRuoliComputed
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "Ruolo outline Ruolo_4",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nRuoliComputed
                                                              .nA
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("edit")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                right: "",
                                              },
                                            },
                                            [_vm._v("open_in_new")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _c("div", { staticClass: "opzione-widget" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end",
                                    },
                                    [
                                      _vm.asta_info.lega.nRuoli.op ==
                                      "illimitati"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    large: "",
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Illimitati / A piacere\n                      "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { right: "" } },
                                                    [_vm._v("lock")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center justify-center",
                                            },
                                            [
                                              _c("v-select", {
                                                staticClass: "ma-2",
                                                attrs: {
                                                  items: [1, 2, 3, 4, 5],
                                                  label: "Por",
                                                  outlined: "",
                                                },
                                                model: {
                                                  value: _vm.nRuoli_nP,
                                                  callback: function ($$v) {
                                                    _vm.nRuoli_nP = $$v
                                                  },
                                                  expression: "nRuoli_nP",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("v-select", {
                                                staticClass: "ma-2",
                                                attrs: {
                                                  items: [
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10, 11, 12,
                                                  ],
                                                  label: "Dif",
                                                  outlined: "",
                                                },
                                                model: {
                                                  value: _vm.nRuoli_nD,
                                                  callback: function ($$v) {
                                                    _vm.nRuoli_nD = $$v
                                                  },
                                                  expression: "nRuoli_nD",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("v-select", {
                                                staticClass: "ma-2",
                                                attrs: {
                                                  items: [
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10, 11, 12,
                                                  ],
                                                  label: "Cen",
                                                  outlined: "",
                                                },
                                                model: {
                                                  value: _vm.nRuoli_nC,
                                                  callback: function ($$v) {
                                                    _vm.nRuoli_nC = $$v
                                                  },
                                                  expression: "nRuoli_nC",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("v-select", {
                                                staticClass: "ma-2",
                                                attrs: {
                                                  items: [
                                                    1, 2, 3, 4, 5, 6, 7, 8, 9,
                                                    10,
                                                  ],
                                                  label: "Att",
                                                  outlined: "",
                                                },
                                                model: {
                                                  value: _vm.nRuoli_nA,
                                                  callback: function ($$v) {
                                                    _vm.nRuoli_nA = $$v
                                                  },
                                                  expression: "nRuoli_nA",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                    ]
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.classic
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                                attrs: { id: "ruolo_da_chiamare" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("gavel")]
                                        ),
                                        _vm._v(
                                          "RUOLO DA CHIAMARE\n                  "
                                        ),
                                        _c("v-badge", {
                                          attrs: {
                                            color: "error",
                                            content: "NEW",
                                            "offset-x": "-5",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v(
                                          "\n                  Utile per le leghe che vogliono fare l'asta ruolo per\n                  ruolo."
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          '\n                  Selezionando "Qualunque ruolo", il chiamante potrà chiamare\n                  all\'asta un calciatore del ruolo che preferisce.\n                '
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "opzione-widget" }, [
                                  _c(
                                    "div",
                                    { on: { click: _vm.handleDisabledClick } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.ruolo_da_chiamare_options,
                                          disabled: _vm.isAstaInCorso,
                                          outlined: "",
                                        },
                                        model: {
                                          value: _vm.ruolo_da_chiamare,
                                          callback: function ($$v) {
                                            _vm.ruolo_da_chiamare = $$v
                                          },
                                          expression: "ruolo_da_chiamare",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mode != _vm.Constants.ASTA_MODE.ASSEGNA
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("gavel")]
                                        ),
                                        _vm._v("CHIAMANTE\n                "),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v("\n                  - "),
                                        _c("strong", [
                                          _vm._v("A turno tutti (senza passo)"),
                                        ]),
                                        _vm._v(
                                          ": la\n                  scelta/estrazione del giocatore da mettere all'asta spetta a\n                  turno ad ogni partecipante, senza possibilità di passare il\n                  turno"
                                        ),
                                        _c("br"),
                                        _vm._v("\n                  - "),
                                        _c("strong", [
                                          _vm._v("A turno tutti (con passo)"),
                                        ]),
                                        _vm._v(
                                          ": come la\n                  precedente ma con la possibilità di passare il turno"
                                        ),
                                        _c("br"),
                                        _vm._v("\n                  - "),
                                        _c("strong", [_vm._v("Solo l'admin")]),
                                        _vm._v(
                                          ": è sempre l'amministratore\n                  di lega a sceglierli/estrarli\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.ch_mode_opt,
                                        disabled: _vm.isAstaInCorso,
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.ch_mode,
                                        callback: function ($$v) {
                                          _vm.ch_mode = $$v
                                        },
                                        expression: "ch_mode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("shuffle")]
                                  ),
                                  _vm._v(
                                    " ESTRAZIONE\n                  CASUALE\n                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v("\n                  - "),
                                _c("strong", [_vm._v("NO")]),
                                _vm._v(
                                  ": il calciatore viene scelto\n                  liberamente dal 'Chiamante'"
                                ),
                                _c("br"),
                                _vm._v("\n                  - "),
                                _c("strong", [_vm._v("SI")]),
                                _vm._v(
                                  ": Il 'Chiamante' estrae il calciatore\n                  in maniera casuale tra i ruoli permessi\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "opzione-widget" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.random_mode_opt,
                                    disabled: _vm.isAstaInCorso,
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.random_mode,
                                    callback: function ($$v) {
                                      _vm.random_mode = $$v
                                    },
                                    expression: "random_mode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.mode !== _vm.Constants.ASTA_MODE.ASSEGNA
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("outlined_flag")]
                                        ),
                                        _vm._v("BASE D'ASTA\n                "),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v(
                                          "\n                  L'offerta minima per ciascun calciatore.\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.offerta_min_opt,
                                        disabled: _vm.isAstaInCorso,
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.base_asta,
                                        callback: function ($$v) {
                                          _vm.base_asta = $$v
                                        },
                                        expression: "base_asta",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !(
                          _vm.latestProp("random_mode") ==
                            _vm.Constants.RANDOM_MODE.ENABLED ||
                          _vm.latestProp("mode") ==
                            _vm.Constants.ASTA_MODE.BUSTA_CHIUSA ||
                          _vm.latestProp("mode") ==
                            _vm.Constants.ASTA_MODE.ADMIN ||
                          _vm.latestProp("ch_mode") ==
                            _vm.Constants.CHOOSER_MODE.ADMIN
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("currency_exchange")]
                                        ),
                                        _vm._v(
                                          "OFFERTA\n                  CONTESTUALE ALLA CHIAMATA?\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v("\n                  - "),
                                        _c("strong", [_vm._v("SI")]),
                                        _vm._v(
                                          ": Quando il 'Chiamante' sceglie un\n                  calciatore sta anche offrendo il valore impostato in 'Base\n                  d'asta' (Attenzione: il sistema mostrerà al chiamante SOLO\n                  gli svincolati aquistabili col suo credito residuo)"
                                        ),
                                        _c("br"),
                                        _vm._v("\n                  - "),
                                        _c("strong", [_vm._v("NO")]),
                                        _vm._v(
                                          ": il 'Chiamante' non fa offerta => se\n                  nessuno farà offerte, il calciatore verrà scartato"
                                        ),
                                        _c("br"),
                                        _c("br"),
                                        _vm._v(
                                          "\n                  Attenzione. Questa impostazione "
                                        ),
                                        _c("b", [_vm._v(" sarà ignorata se")]),
                                        _vm._v(
                                          ": a)\n                  la modalità è Busta Chiusa, b) il chiamante è sempre l'admin\n                  o c) l'estrazione è casuale.\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "opzione-widget" },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.offerta_auto_opt,
                                        disabled: _vm.isAstaInCorso,
                                        outlined: "",
                                      },
                                      model: {
                                        value: _vm.offerta_auto,
                                        callback: function ($$v) {
                                          _vm.offerta_auto = $$v
                                        },
                                        expression: "offerta_auto",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("sort")]
                                  ),
                                  _vm._v(
                                    "ORDINA SVINCOLATI PER\n                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v(
                                  "\n                  Utile per le leghe che chiamano i calciatori da mettere\n                  all'asta in ordine alfabetico o quotazione.\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "opzione-widget" },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.chooser_list_order_opt,
                                    disabled: _vm.isAstaInCorso,
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.ch_list_order,
                                    callback: function ($$v) {
                                      _vm.ch_list_order = $$v
                                    },
                                    expression: "ch_list_order",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("av_timer")]
                                  ),
                                  _vm._v(
                                    " TIMEOUT CHIAMATA\n                  CALCIATORE\n                "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v(
                                  "\n                  Quanto tempo ha a disposizione il 'Chiamante' per\n                  scegliere/estrarre il calciatore? Passato questo tempo, il\n                  sistema sceglierà automaticamente il primo della lista degli\n                  svincolati del ruolo visualizzato in quel momento.\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "opzione-widget" },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    type: "number",
                                    suffix: "secondi",
                                    disabled: true,
                                  },
                                  model: {
                                    value: _vm.timeout_c,
                                    callback: function ($$v) {
                                      _vm.timeout_c = $$v
                                    },
                                    expression: "timeout_c",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-slider", {
                                  attrs: {
                                    max: 300,
                                    min: 5,
                                    disabled: _vm.isAstaInCorso,
                                    step: "5",
                                    snap: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.timeout_c,
                                    callback: function ($$v) {
                                      _vm.timeout_c = $$v
                                    },
                                    expression: "timeout_c",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("av_timer")]
                                  ),
                                  _vm._v("TIMEOUT RILANCIO\n                "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "opzione-descr" }, [
                                _vm._v(
                                  "\n                  Una volta che è stato scelto il calciatore da mettere\n                  all'asta, quanto tempo ha a disposizione ciascun\n                  partecipante per decidere se fare un'offerta o passare?\n                  Scaduto tale tempo, il sistema forzerà un PASSO\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "opzione-widget" },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    type: "number",
                                    suffix: "secondi",
                                    disabled: true,
                                  },
                                  model: {
                                    value: _vm.timeout_s,
                                    callback: function ($$v) {
                                      _vm.timeout_s = $$v
                                    },
                                    expression: "timeout_s",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-slider", {
                                  staticClass: "mb-0 mt-0",
                                  attrs: {
                                    max: 300,
                                    min: 5,
                                    disabled: _vm.isAstaInCorso,
                                    "hide-details": "",
                                    step: "5",
                                    snap: "",
                                  },
                                  model: {
                                    value: _vm.timeout_s,
                                    callback: function ($$v) {
                                      _vm.timeout_s = $$v
                                    },
                                    expression: "timeout_s",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.Config.STANDALONE
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "opzione-titolo-descr" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "opzione-titolo" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "text", left: "" },
                                          },
                                          [_vm._v("production_quantity_limits")]
                                        ),
                                        _vm._v(
                                          "MAX CALCIATORI PER CLUB PER RUOLO\n                "
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "opzione-descr" },
                                      [
                                        _vm._v(
                                          "\n                  Es: impostando 2 una fantasquadra potrà avere massimo 2\n                  attaccanti (e max 2 centrocampisti, max 2 difensori, max 2\n                  portieri) di ciascun club (Inter, Milan...)\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "opzione-widget" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-decoration-none",
                                      attrs: {
                                        target: "_blank",
                                        href:
                                          _vm.Config.HOST +
                                          "/fantacalcio/modifica-limitRosaPerClub/" +
                                          _vm.asta_info.id,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            outlined: "",
                                            large: "",
                                            depressed: "",
                                            disabled: _vm.isAstaInCorso,
                                          },
                                        },
                                        [
                                          _vm.limitRosaPerClub &&
                                          _vm.limitRosaPerClub.perClubPerRuolo
                                            .active == 1
                                            ? _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.limitRosaPerClub
                                                        .perClubPerRuolo.valore
                                                    ) +
                                                      " per\n                        ruolo"
                                                  ),
                                                ]),
                                              ])
                                            : _c("div", [
                                                _c("span", [
                                                  _vm._v("Nessun limite"),
                                                ]),
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            { attrs: { right: "" } },
                                            [_vm._v("edit")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                "x-small": "",
                                                right: "",
                                              },
                                            },
                                            [_vm._v("open_in_new")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "opzione d-flex flex-column align-start flex-md-row justify-md-space-between",
                          },
                          [
                            _c("div", { staticClass: "opzione-titolo-descr" }, [
                              _c(
                                "div",
                                { staticClass: "opzione-titolo" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "text", left: "" } },
                                    [_vm._v("mode_edit")]
                                  ),
                                  _vm._v("ALTRE MODIFICHE\n                "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.Config.STANDALONE
                                ? _c("div", { staticClass: "opzione-descr" }, [
                                    _vm._v(
                                      '\n                  Altre opzioni (es: modifica dei crediti di squadra) le trovi\n                  direttamente nella schermata principale (cliccando sulle\n                  squadre intorno al "tavolo")\n                '
                                    ),
                                  ])
                                : _c("div", { staticClass: "opzione-descr" }, [
                                    _vm._v(
                                      '\n                  Altre opzioni le trovi sia nella schermata principale\n                  (cliccando sulle squadre intorno al "tavolo") che sul\n                  sito/app. Ricorda però che se modifichi qualcosa sul\n                  sito/app, poi in Asta Live dovrai sincronizzare le modifiche\n                  e perderai le eventuali assegnazioni non salvate.\n                '
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "opzione-widget" }),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }